import React from "react";

export const GlobalStateContext = React.createContext();
export const GlobalDispatchContext = React.createContext();

const initialState = {
  pinModalContent: null,
  showNavigator: false,
  viewMode: "NORMAL" // HIDE-COMMENT, HTML, NORMAL
};

function reducer(state, action) {
  switch (action.type) {
    case "PIN_MODAL": {
      return {
        ...state,
        pinModalContent: action.pinModalContent,
      };
    }

    case "SHOW_NAVIGATOR": {
      return {
        ...state,
        showNavigator: true,
      };
    }

    case "HIDE_NAVIGATOR": {
      return {
        ...state,
        showNavigator: false,
      };
    }

    case "CHANGE_VIEW_MODE": {
      return {
        ...state,
        viewMode: action.viewMode,
      };
    }

    default:
      throw new Error("Bad Action Type");
  }
}

const GlobalContextProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  return (
    <GlobalStateContext.Provider value={state}>
      <GlobalDispatchContext.Provider value={dispatch}>
        {children}
      </GlobalDispatchContext.Provider>
    </GlobalStateContext.Provider>
  );
};

export default GlobalContextProvider;
